import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-view" }

import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { Company } from '@/gql/graphql';
import { isContractActive } from '@/helpers/isContractActive';
import { getCompanyContractsDates } from '@/services/CommonService';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const user = computed(() => store.getters['cabinet/user']);
const getCompanyRouteTypeById = computed(() => store.getters['cabinet/getCompanyRouteTypeById']);

onMounted(async () => {
  const companies: Company[] = user.value.companies;
  if (!companies.length) {
    return;
  }

  const company: Company = user.value.companies[0];
  switch (company.role) {
    case 'accountant': {
      router.replace({
        name: 'accountant/settlements',
        params: {
          id: company.id,
          type: 'company',
        },
      });

      return;
    }
  }

  let id: string;

  const companyType = getCompanyRouteTypeById.value(company.id);
  // если несколько контрактов
  if (company.type !== 'internal' && company.contracts.length > 1) {
    const response = await getCompanyContractsDates({ companyId: company.id });
    const contracts = response.cabinet?.company?.contracts;
    if (contracts) {
      // берём в качестве id первый активный договор
      const activeContract = contracts.find(isContractActive);
      // если активных нет, открываем первый попавшийся контракт
      id = activeContract?.id ?? contracts[0].id;
    } else {
      id = company.contracts[0].id;
    }
  } else {
    // если АЗС, то открываем контракт
    if (companyType === 'station') {
      const contractId = company.contract?.id;
      if (!contractId) {
        // по идее эта ошибка никогда не должна быть вызвана
        throw new Error('Не найден контракт компании');
      }

      id = contractId;
    } else {
      // для всех остальных компанию
      id = company.id;
    }
  }

  router.replace({
    name: 'orders',
    params: {
      type: companyType,
      id,
    },
    query: route.query,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})